import { StaticMenuApiData } from "../models/staticmenu.models";
import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";

export async function getChannelMenu() {
  return await apiCall.get(API_URL.CHANNEL.GET_CHANNEL_MENU);
}

export async function getChannelMenuPage(path: string) {
  return await apiCall.get(API_URL.CHANNEL.GET_CHANNEL_MENU_PAGE + path);
}

export async function getChannelSubmenu(path: string) {
  return await apiCall.get(API_URL.CHANNEL.GET_CHANNEL_SUBMENU + path);
}

export async function getMediaTypeChannel(type: string, media_type: string) {
  return await apiCall.get(
    API_URL.CHANNEL.GET_MEDIA_TYPE_CHANNEL + type + "/" + media_type
  );
}
export async function saveChannelMenu(data: any) {
  return await apiCall.post(API_URL.CHANNEL.SAVE_CHANNEL_MENU, data);
}

export async function saveChannelDetails(data: StaticMenuApiData) {
  return await apiCall.post(API_URL.CHANNEL.SAVE_CHANNEL_DETAILS, data);
}

export async function saveChannelInteractivePoint(data: {
  pos_x: number;
  pos_y: number;
  point_id: number | string;
  channel_image_id: number;
}) {
  return await apiCall.post(
    API_URL.CHANNEL.SAVE_CHANNEL_INTERACTIVE_POINT,
    data
  );
}

export async function deleteChannelInteractivePoint(id: number) {
  return await apiCall.remove(
    API_URL.CHANNEL.DELETE_CHANNEL_INTERACTIVE_POINT + "/" + id
  );
}
